import { datadogRum } from '@datadog/browser-rum';

/**
 * Send error report with specified context and additional metadata if needed.
 *
 * @param {Error} error - The error object that needs to be reported.
 * @param {string} source - Context in which the error occurred.
 * @param {object} context - Additional metadata for the error.
 */
function sendErrorReport(error: Error, source: string, context?: object) {
  datadogRum.addError(error, { source, ...context });
}

export default sendErrorReport;
